export default {"src":"/_next/static/media/video-bg.bacbb867.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};